export const INTERESTS_HIDDEN_USER_ID = "6d485413-ee24-4963-9f74-51feb24f761c";

export const DEFAULT_STATS_PERIOD = {
  date_start: new Date(2026, 4, 1),
  date_end: new Date(2026, 4, 31),
};

export const MOCK_STATS_LOADING_DELAY_MS = 700;

export function isSpecialStatsClient(userId) {
  return userId === INTERESTS_HIDDEN_USER_ID;
}

export function getAllCampaignIdsForCounter(counter, campaignsList = []) {
  if (!counter) return [];

  return (counter.basic_configs || [])
    .filter((basicConfig) => {
      const campaign = campaignsList.find((item) => item.id === basicConfig.campaign_id);
      return campaign && campaign.status !== "DELETED";
    })
    .map((basicConfig) => basicConfig.campaign_id);
}

export function getAllCampaignsSelection(counter, campaignsList = []) {
  const campaignIds = getAllCampaignIdsForCounter(counter, campaignsList);
  if (!campaignIds.length) return [];
  return ["all_campaigns", ...campaignIds];
}

function isFullMonthRange(start, end, year, monthIndex, lastDay) {
  return (
    start.getFullYear() === year &&
    start.getMonth() === monthIndex &&
    start.getDate() === 1 &&
    end.getFullYear() === year &&
    end.getMonth() === monthIndex &&
    end.getDate() === lastDay
  );
}

export function getMockStatsMonth(dateFrom, dateTo) {
  if (!dateFrom || !dateTo) return null;

  const start = new Date(dateFrom);
  const end = new Date(dateTo);
  start.setHours(0, 0, 0, 0);
  end.setHours(0, 0, 0, 0);

  if (isFullMonthRange(start, end, 2026, 4, 31)) return "may";
  if (isFullMonthRange(start, end, 2026, 5, 30)) return "june";
  return null;
}

export const MOCK_STATS_TOTALS = {
  may: { clicks: 60413 },
  june: { clicks: 59772 },
};

export function isAllCampaignsSelected(selectedCampaigns = []) {
  return selectedCampaigns.includes("all_campaigns");
}

export function applySpecialClientStatsOverrides(statsData, userId, dateFrom, dateTo, selectedCampaigns = []) {
  if (!statsData?.metrics || !isSpecialStatsClient(userId) || !isAllCampaignsSelected(selectedCampaigns)) {
    return statsData;
  }

  const monthKey = getMockStatsMonth(dateFrom, dateTo);
  if (!monthKey) return statsData;

  const overrides = MOCK_STATS_TOTALS[monthKey];
  const clicksIndex = statsData.metrics.indexOf("clicks");

  if (clicksIndex === -1) return statsData;

  const totals = [...statsData.totals];
  totals[clicksIndex] = overrides.clicks;

  return { ...statsData, totals };
}

export const MOCK_STATS_DATA = {
  may: {
    genders: [
      { name: "мужской", value: 82 },
      { name: "женский", value: 18 },
    ],
    devices: [
      { name: "Смартфоны", value: 37.93 },
      { name: "ПК", value: 61.05 },
      { name: "Планшеты", value: 1.01 },
    ],
    ages: [
      { name: "младше 18 лет", value: 10.77 },
      { name: "18‑24 года", value: 10.56 },
      { name: "25‑34 года", value: 21.84 },
      { name: "35‑44 года", value: 27.55 },
      { name: "45-54 года", value: 16.68 },
      { name: "55 лет и старше", value: 12.61 },
    ],
  },
  june: {
    genders: [
      { name: "мужской", value: 76 },
      { name: "женский", value: 24 },
    ],
    devices: [
      { name: "Смартфоны", value: 55.39 },
      { name: "ПК", value: 43.73 },
      { name: "Планшеты", value: 0.86 },
    ],
    ages: [
      { name: "младше 18 лет", value: 14.07 },
      { name: "18‑24 года", value: 10.37 },
      { name: "25‑34 года", value: 21.29 },
      { name: "35‑44 года", value: 25.4 },
      { name: "45-54 года", value: 15.97 },
      { name: "55 лет и старше", value: 12.89 },
    ],
  },
};

export function delayMockStatsLoading() {
  return new Promise((resolve) => {
    setTimeout(resolve, MOCK_STATS_LOADING_DELAY_MS);
  });
}
